// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".signup-back-button[data-v-7fc27550]{top:3.5rem;left:4rem}@media (min-width:1024px){.signup-back-button[data-v-7fc27550]{top:5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
